import { SpineGameObject } from "@esotericsoftware/spine-phaser";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
export enum LinkCellType {
    NORMAL,
    FIXED
}

export default class LinkCell {
    private ANIM_ENTER_MAP: { [key: number]: string } = {
        [ResourcesDispatcher.GAME_CONSTANTS.S_MINI]: "mini_enter",
        [ResourcesDispatcher.GAME_CONSTANTS.S_MINOR]: "minor_enter",
        [ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR]: "major_enter",
        [ResourcesDispatcher.GAME_CONSTANTS.S_GRAND]: "grand_enter"
    }

    private ANIM_EXIT_MAP: { [key: number]: string } = {
        [ResourcesDispatcher.GAME_CONSTANTS.S_MINI]: "mini_exit",
        [ResourcesDispatcher.GAME_CONSTANTS.S_MINOR]: "minor_exit",
        [ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR]: "major_exit",
        [ResourcesDispatcher.GAME_CONSTANTS.S_GRAND]: "grand_exit"
    }
    
    public scene: any;

    private container: Phaser.GameObjects.Container;

    private memo: number = 0;
    private index: number;

    public x: number;
    public y: number;

    private linkSpineWithText: SpineGameObject;
    private linkSpineWithValue: SpineGameObject;
    private linkSpineValueText: Phaser.GameObjects.Text;
    public linkSpinTextValueTween: Phaser.Tweens.Tween | null = null;

    private isStopped: boolean = false;

    private linkSpinSymbolSpineRaw: any;

    private linkSpinParticleAnimation: SpineGameObject;
    private linkSpinSymbolSpines: SpineGameObject[];
    private background: Phaser.GameObjects.Image;

    public multValue!: number;
    public spinTween?: Phaser.Tweens.Tween;
    public celebrateLinkResolve: ((value: boolean | PromiseLike<boolean>) => void) | null = null;
    public timerCelebrateLinkWin: Phaser.Time.TimerEvent | null = null;

    // Properties for moving value text animation
    public movingValueText: Phaser.GameObjects.Text | null = null;
    public movingValueTween: Phaser.Tweens.Tween | null = null;
    public valueCollected: boolean = false;

    private linkCellType: LinkCellType;
    private cellLocked: boolean = false;
    public linkReel: any; // Riferimento al LinkReel a cui appartiene questa cella
    private linkFont: Phaser.Types.GameObjects.Text.TextStyle = (window as any).GlobalVariableManager.getFont().overrideFont({fontSize: 50,color: "#FFEE00"});

    constructor(scene: any, x: number, y: number, index: number, linkReel: any, type: LinkCellType = LinkCellType.NORMAL) {
        this.scene = scene;
        this.linkReel = linkReel;

        this.x = x;
        this.y = y;
        this.index = index;
        this.linkCellType = type;

        this.linkSpinSymbolSpineRaw = ResourcesDispatcher.GAME_CONSTANTS.linkSymbolSpines;

        this.linkSpinSymbolSpines = [];
        for (let i = 0; i < this.linkSpinSymbolSpineRaw.length; i++) {
            let spine = this.scene.add.spine(0, 0, this.getLinkSpinSymbolSpineRaw(i).jsonKey, this.getLinkSpinSymbolSpineRaw(i).atlasKey).setOrigin(0.5).setVisible(false);
            this.linkSpinSymbolSpines.push(spine);
        }

        this.container = this.scene.add.container(this.x, this.y, [...this.linkSpinSymbolSpines]);

        this.background = this.scene.add.image(0, 0, ResourcesDispatcher.ATLAS.LINKCELL_BACKGROUND.key, ResourcesDispatcher.ATLAS.LINKCELL_BACKGROUND.frameKey).setOrigin(0.5).setVisible(false);
        this.linkSpinParticleAnimation = this.scene.add.spine(0, 0, ResourcesDispatcher.SPINES.LinkSpin_Particle_Animation.jsonKey, ResourcesDispatcher.SPINES.LinkSpin_Particle_Animation.atlasKey).setScale(.4).setOrigin(0.5).setVisible(false);

        this.linkSpineWithText = this.linkSpinSymbolSpines[ResourcesDispatcher.GAME_CONSTANTS.S_LINK];
        this.linkSpineWithValue = this.scene.add.spine(0, 0, ResourcesDispatcher.SPINES.LinkSpin.jsonKey, ResourcesDispatcher.SPINES.LinkSpin.atlasKey).setOrigin(0.5).setVisible(false);

        this.linkSpineValueText = this.scene.add.text(0, 0, "", this.linkFont).setOrigin(0.5).setVisible(false);
        
        this.container.add([this.linkSpineWithValue, this.linkSpineValueText, this.linkSpinParticleAnimation]);
        this.container.addAt(this.background, 0);
    }

    public resetPosition() {
        this.container.setPosition(this.x, this.y);
    }

    public setIndex(index: number) {
        this.index = index;
    }

    public setMemo(memo: number): void {
        this.memo = memo;
    }

    /** PUBLIC GETTERS **/
    public getIndex(): number {
        return this.index;
    }

    public getMemo(): number {
        return this.memo;
    }

    public getContainer(): Phaser.GameObjects.Container {
        return this.container;
    }   

    public getSpine(memo: number): SpineGameObject {
        return this.linkSpinSymbolSpines[memo];
    }

    public getBackground(): Phaser.GameObjects.Image {
        return this.background;
    }

    public getLinkSpineWithText(): SpineGameObject {
        return this.linkSpineWithText;
    }

    public getLinkSpineWithValue(): SpineGameObject {
        return this.linkSpineWithValue;
    }

    public getLinkSpineValueText(): Phaser.GameObjects.Text {
        return this.linkSpineValueText;
    }
    /*******************/

    /** PRIVATE GETTERS **/
    private getLinkSpinSymbolSpineRaw(memo: number): any {
        return this.linkSpinSymbolSpineRaw[memo];
    }
    /*******************/

    public isCellLocked(): boolean {
        return this.cellLocked;
    }
    
    public setCellInfo(cellMemo: number): LinkCell {
        this.linkSpinSymbolSpines.forEach((spine) => {
            spine.setVisible(false);
        });

        this.linkSpineValueText.setScale(1);

        this.getSpine(cellMemo).setVisible(true);
        this.getSpine(cellMemo).animationState.clearTrack(0);
        this.getSpine(cellMemo).skeleton.setToSetupPose();

        this.setMemo(cellMemo);

        return this;
    }

    public lockIfNeeded(animate: boolean = false): Promise<void> {
        return new Promise(async (resolve) => {
            if (this.linkCellType !== LinkCellType.FIXED) {
                resolve();
                return;
            }

            if (this.cellLocked) {
                resolve();
                return;
            }
            
            if (this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK || this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED) {
                this.cellLocked = false;
                resolve();
                return;
            }

            let extraSymbolsInfo = null;
            switch (this.getMemo()) {
                case ResourcesDispatcher.GAME_CONSTANTS.S_MINI:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.miniLink > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.miniLink === this.linkReel.getIndex() % 5)[0];
                    break;
                case ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.majorLink > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.majorLink === this.linkReel.getIndex() % 5)[0];
                    break;
                case ResourcesDispatcher.GAME_CONSTANTS.S_GRAND:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.grandLink > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.grandLink === this.linkReel.getIndex() % 5)[0];
                    break;
                case ResourcesDispatcher.GAME_CONSTANTS.S_MINOR:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.minorLink > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.minorLink === this.linkReel.getIndex() % 5)[0];
                    break;
                case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X2:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x2 > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x2 === this.linkReel.getIndex() % 5)[0];
                    break;
                case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X3:
                    extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x3 > -1)
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
                        ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x3 === this.linkReel.getIndex() % 5)[0];
                    break;
            }

            if (!extraSymbolsInfo) {
                this.cellLocked = false;
                resolve();
                return;
            }

            if (!extraSymbolsInfo.activeStatus) {
                this.cellLocked = true;
                resolve();
            } else {
                this.cellLocked = false;
                resolve();
            }
        });
    }

    public unlockIfNeeded(animate: boolean = false): Promise<void> {
        return new Promise(async(resolve) => {
            if (this.linkCellType !== LinkCellType.FIXED) {
                resolve();
                return;
            }

            if (!this.cellLocked) {
                resolve();
                return;
            }
            this.cellLocked = false;
            // this.linkLockedText.setVisible(false);
            
            resolve();
        });
    }

    public playAnimation(loop: boolean = false): Promise<boolean> {
        return new Promise((resolve) => {

            if (this.linkCellType === LinkCellType.NORMAL) {
                resolve(true);
                return;
            }

            const animations = this.getLinkSpinSymbolSpineRaw(this.getMemo()).animations;
            if (animations) {

                let animationName = this.ANIM_ENTER_MAP[this.getMemo()] || animations[0];
                const trackEntry = this.getSpine(this.getMemo()).animationState.addAnimation(0, animationName, loop);
                trackEntry.alpha = 1;

                this.getSpine(this.getMemo()).setVisible(true);
                // TODO: add locked animation if needed 1

                // Add a new 'complete' listener
                if (!loop) {
                    trackEntry.listener = {
                        complete: () => {
                            // this.getSpine(this.getMemo()).animationState.clearTrack(0);
                            // this.getSpine(this.getMemo()).skeleton.setToSetupPose();
                            resolve(true);
                        }

                    };
                } else {
                    resolve(true);
                }
            } else {
                resolve(true);
            }
        });
    }

    public stopAnimation(): void {
        if (this.linkCellType === LinkCellType.NORMAL) {
            return;
        }

        if (this.getMemo() <= ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED) {
            this.getSpine(ResourcesDispatcher.GAME_CONSTANTS.MAP_LINK_SPINES_FROM_POSITION[this.getMemo()]).animationState.clearTrack(0);
            this.getSpine(ResourcesDispatcher.GAME_CONSTANTS.MAP_LINK_SPINES_FROM_POSITION[this.getMemo()]).skeleton.setToSetupPose();
        }
    }  

    public playLinkSpinParticleAnimation(): Promise<boolean> {
        return new Promise(async (resolve) => {
            this.linkSpinParticleAnimation.setVisible(true);
            const animations = ResourcesDispatcher.SPINES.LinkSpin_Particle_Animation.animations;

            if (animations) {
                this.linkSpinParticleAnimation.animationState.timeScale = 0.8;
                this.linkSpinParticleAnimation.animationState.setAnimation(0, animations[0], false);
            }

            const animationStateListener : any= {
                complete: async () => {
                    // Remove this specific listener after it is called
                    this.linkSpinParticleAnimation.animationState.removeListener(animationStateListener);
                    this.linkSpinParticleAnimation.setVisible(false);
                    resolve(true);
                }
            };

            this.linkSpinParticleAnimation.animationState.addListener(animationStateListener);
        });
    }

    public celebrateLinkWin(animationIndex : number): Promise<boolean> {
        return new Promise(async (resolve) => {

            if (this.linkCellType !== LinkCellType.FIXED) {
                resolve(true);
                return;
            }

            this.celebrateLinkResolve = resolve;
            if (!this.scene.linkGameArea.shouldCollectAnimationRun) {
                this.celebrateLinkResolve(true);
                return;
            }

            if (this.cellLocked) {
                this.celebrateLinkResolve(true);
                return;
            }


            this.timerCelebrateLinkWin = this.scene.time.delayedCall(1000 * animationIndex, async() => {
                switch (this.getMemo()) {
                    case ResourcesDispatcher.GAME_CONSTANTS.S_LINK:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED:
                    //     this.linkSpinTextValueTween = this.linkSpineValueText.scene.tweens.add({
                    //         targets: this.linkSpineValueText,
                    //         scaleX: 1.2,
                    //         scaleY: 1.2,
                    //         duration: 500,
                    //         yoyo: true,
                    //         repeat: 1,
                    //         onStart: () => {
                    //             if (!this.scene.linkGameArea.shouldCollectAnimationRun) {
                    //                 this.celebrateLinkResolve?.(true);
                    //                 return;
                    //             }
                    //         },
                    //         onComplete: async () => {
                    //             this.linkSpinTextValueTween?.stop();
                    //             this.linkSpinTextValueTween?.remove();
                    //             this.linkSpinTextValueTween?.destroy();
                    //         }
                    //     });
                    // break;
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINI:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINOR:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_GRAND:
                        if (!this.scene.linkGameArea.shouldCollectAnimationRun) {
                            this.celebrateLinkResolve?.(true);
                            return;
                        }
                }
                
                await this.scene.animationManager.leftSideGridAnimation?.shoot();
                await this.playExitAnimation(this.ANIM_EXIT_MAP[this.getMemo()]);
                
                // Create and animate the moving value text
                await this.animateValueToGridWinBox();
                
                this.celebrateLinkResolve?.(true);
            });
        });
    }

     /**
     * Animates the value text from the cell position to the grid win box
     */
    private async animateValueToGridWinBox(): Promise<void> {
        return new Promise((resolve) => {
            if (!this.scene.linkGameArea.shouldCollectAnimationRun) {
                resolve();
                return;
            }

            // Get the world position of this cell's container
            const cellWorldPos = this.container.getWorldTransformMatrix();
            const cellX = cellWorldPos.tx;
            const cellY = cellWorldPos.ty;
            
            // Get the scale from the game area layer
            const scale = this.scene.linkGameArea.linkScale;
            // Create text at world position, not in any container
            this.movingValueText = this.scene.add.text(cellX, cellY, Utils.formatValue(this.multValue), this.linkFont).setOrigin(0.5).setScale(scale).setDepth(10000);

            // Hide the original text
            this.linkSpineValueText.setVisible(false);
            this.linkSpineValueText.setText("");
            // this.linkSpineValueText.setScale(1);

            // Get the target position (grid win box) - this is already in world coordinates
            const targetPos = this.scene.linkGameArea.getGridWinBoxWorldPosition();

            // Animate the text to the target position
            this.movingValueTween = this.scene.tweens.add({
                targets: this.movingValueText,
                x: targetPos.x,
                y: targetPos.y,
                scale: scale * 0.5,
                alpha: 0.8,
                duration: 800,
                ease: "Cubic.easeInOut",
                onUpdate: () => {
                    // Update target position in case of orientation change
                    if (this.movingValueTween && this.movingValueText) {
                        const currentTargetPos = this.scene.linkGameArea.getGridWinBoxWorldPosition();
                        const currentScale = this.scene.linkGameArea.linkScale;
                        
                        // Only update the tween target if position changed significantly
                        if (Math.abs(currentTargetPos.x - targetPos.x) > 10 || Math.abs(currentTargetPos.y - targetPos.y) > 10) {
                            this.movingValueTween.updateTo('x', currentTargetPos.x, true);
                            this.movingValueTween.updateTo('y', currentTargetPos.y, true);
                            this.movingValueTween.updateTo('scale', currentScale * 0.5, true);
                            targetPos.x = currentTargetPos.x;
                            targetPos.y = currentTargetPos.y;
                        }
                    }
                },
                onComplete: () => {
                    // Increment the grid win box value
                    this.scene.linkGameArea.increaseWinBoxValue(this.multValue);
                    
                    // Mark value as collected
                    this.valueCollected = true;
                    
                    // Destroy the moving text
                    if (this.movingValueText) {
                        this.movingValueText.destroy();
                        this.movingValueText = null;
                    }
                    
                    resolve();
                }
            });
        });
    }

    /**
     * Ferma immediatamente la celebrazione di una cella
     */
    public stopCelebrateLinkWin(): void {
        // ✨ Imposta flag per far uscire celebrateLinkWin() ai prossimi controlli
        this.isStopped = true;

        // Pulisci il testo del valore
        this.cleanLinkValueText();

        // Ferma l'animazione della particella
        this.linkSpinParticleAnimation.animationState.clearTrack(0);
        this.linkSpinParticleAnimation.setVisible(false);

        // Ferma il tween del valore se esiste
        if (this.linkSpinTextValueTween) {
            this.linkSpinTextValueTween.stop();
            this.linkSpinTextValueTween.remove();
            this.linkSpinTextValueTween.destroy();
            this.linkSpinTextValueTween = null;
        }

        // Stop the moving value tween (but keep the text for the manager to handle)
        if (this.movingValueTween) {
            this.movingValueTween.stop();
            this.movingValueTween.remove();
            this.movingValueTween.destroy();
            this.movingValueTween = null;
        }

        // Ferma l'animazione spine del simbolo
        this.stopAnimation();

        // ✨ CRUCIALE: Risolvi la promise della celebrazione SUBITO
        // Questo fa sì che celebrateLinkWin() si risolva anche se è bloccata in await
        if (this.celebrateLinkResolve) {
            this.celebrateLinkResolve(true);
        }

        // Cancella il timer in sospeso
        if (this.timerCelebrateLinkWin) {
            this.timerCelebrateLinkWin.destroy();
        }
    }

    private playExitAnimation(animation: string): Promise<boolean> {
        return new Promise(async (resolve) => {
            await this.playLinkSpinParticleAnimation();

            const overlaySpineIndex = 19;
            const overlaySpine = this.getSpine(overlaySpineIndex);
            const animations = this.getLinkSpinSymbolSpineRaw(overlaySpineIndex).animations;

            if (!overlaySpine || !animations) return resolve(true);

            const animIndex = animations.indexOf(animation);
            if (animIndex === -1) return resolve(true);

            overlaySpine.animationState.clearTrack(1);
            const trackEntry = overlaySpine.animationState.addAnimation(1, animations[animIndex], false);

            if (trackEntry) {
                trackEntry.alpha = 1;
                trackEntry.timeScale = 2;
                trackEntry.listener = {
                    complete: () => {
                        overlaySpine.skeleton.setToSetupPose();
                        resolve(true);
                    }
                };
            } else {
                resolve(true);
            }
        });
    }

    private cleanLinkValueText(): void {
        this.linkSpineValueText.setVisible(false);
        this.linkSpineValueText.setText("");
        this.linkSpineValueText.setScale(1);
    }

    // reset eventuale tween vecchio (se lo usavi ancora)
    public startCoinSpin(): void {
        const memo = this.getMemo();
        const spine = this.getSpine(memo);

        if (!spine) return;

        // nascondi eventuali animazioni precedenti
        spine.animationState.clearTracks();

        // mostra solo questo spine (in caso alcuni fossero hidden)
        this.linkSpinSymbolSpines.forEach(s => s.setVisible(false));
        spine.setVisible(true);

        // verifica che l'animazione "anim" esista
        const animations = this.getLinkSpinSymbolSpineRaw(memo).animations;

        if (!animations || !animations.includes("rotation")) {
            console.warn(`LinkCell: anima "rotation" non trovata per memo: ${memo}`);
            return;
        }

        if(!ResourcesDispatcher.GAME_CONSTANTS.linkSymbols.includes(this.getMemo())) {
            spine.skeleton.color.set(0.5, 0.5, 0.5, 1);
        }

        // ✨ avvia l'animazione "rotation" in loop infinito
        const trackentry = spine.animationState.setAnimation(0, "rotation", true);
        trackentry.timeScale = 2; // velocizza l'animazione
    }

    public stopCoinSpin(): void {
        const memo = this.getMemo();
        const spine = this.getSpine(memo);

        if (!spine) return;

        // stop animazione
        spine.animationState.clearTrack(0);
        spine.skeleton.setToSetupPose();
    }

    public async enableLinkCell(memo: number, multiplierValue: number, gracefullAppear: boolean = false): Promise<boolean> {
        return new Promise(async (resolve) => {
            this.setCellInfo(memo);

            if (multiplierValue) {
                switch (this.getMemo()) {
                    case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X2:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X3:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINI:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINOR:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR:
                    case ResourcesDispatcher.GAME_CONSTANTS.S_GRAND:
                        this.linkSpineValueText.setText('');
                        break;
                    default:
                        this.linkSpineValueText.setText(Utils.formatValue(multiplierValue));
                        break;
                }
            }

            this.multValue = multiplierValue;

            
            if (this.linkCellType === LinkCellType.FIXED) {
                this.background.setVisible(true);
                this.getSpine(this.getMemo()).skeleton.setToSetupPose();
                this.getSpine(this.getMemo()).setVisible(true);
                this.linkSpineValueText.setVisible(true);
            }

            this.resetPosition();

            if (!gracefullAppear) {
                this.container.setAlpha(1);
                this.container.setVisible(true);
                resolve(true);
            } else {
                this.container.setAlpha(0);
                this.container.setVisible(true);
                this.scene.tweens.add({
                    targets: this.container,
                    alpha: 1,
                    duration: 300,
                    ease: 'Power2',
                    onComplete: () => {
                        this.container.setAlpha(1);
                        resolve(true);
                    }
                });
            }

        });
    }

    public disableLinkCell() {
        this.setCellInfo(0);
        this.multValue = 0;
        
        this.cellLocked = false; // TODO: check if needed
        
        if (this.linkCellType === LinkCellType.FIXED) {
            this.linkSpineValueText.setVisible(false);
            this.background.setVisible(false);
            this.linkSpineValueText.setText("");
            this.getSpine(this.getMemo()).setVisible(true);
            
            // Clean up moving value text animation properties
            if (this.movingValueTween) {
                this.movingValueTween.stop();
                this.movingValueTween.remove();
                this.movingValueTween.destroy();
                this.movingValueTween = null;
            }
            
            if (this.movingValueText) {
                this.movingValueText.destroy();
                this.movingValueText = null;
            }
            
            // Reset value collection flag
            this.valueCollected = false;
            
            // Clear any pending celebration timers
            if (this.timerCelebrateLinkWin) {
                this.timerCelebrateLinkWin.destroy();
                this.timerCelebrateLinkWin = null;
            }
            
            // Reset celebration resolve callback
            this.celebrateLinkResolve = null;
            
            // Stop and clear any link spin text tweens
            if (this.linkSpinTextValueTween) {
                this.linkSpinTextValueTween.stop();
                this.linkSpinTextValueTween.remove();
                this.linkSpinTextValueTween.destroy();
                this.linkSpinTextValueTween = null;
            }
        }
    }

    public showLinkCellValueText(excludeJackpots: boolean = false) {
        if (this.linkCellType !== LinkCellType.FIXED) {
            return;
        }
        
        if (this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X2 || this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X3) {
            return;
        }

        if (excludeJackpots) {
            if (this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MINI ||
                this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MINOR ||
                this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR ||
                this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_GRAND) {
                return;
            }
        }

        this.linkSpineValueText.setVisible(true);
        this.linkSpineValueText.setText(Utils.formatValue(this.multValue));
    }

    public incrementLinkCellValue(incrementValueTotal: number): Promise<boolean> {
        const waitTime = 500; // Tempo di attesa in millisecondi prima di incrementare il valore
        return new Promise(async (resolve) => {
            if (this.linkCellType !== LinkCellType.FIXED) {
                resolve(true);
                return;
            }

            // show the link cell value text for every link cell involved in the line and increment the value
            this.showLinkCellValueText();
            await Utils.wait(waitTime, this.scene);

            if (this.multValue === incrementValueTotal) {
                await Utils.wait(waitTime, this.scene);
                resolve(true);
                return;
            } else {
                // animate the text increment with a tween
                const startValue = this.multValue;
                const endValue = incrementValueTotal;
                const duration = 2000;
                const incrementTween = this.scene.tweens.addCounter({
                    from: startValue,
                    to: endValue,
                    duration: duration,
                    ease: 'Linear',
                    onUpdate: () => {
                        const currentValue = Math.floor(incrementTween.getValue() || 0);
                        this.linkSpineValueText.setText(Utils.formatValue(currentValue));
                    },
                    onComplete: async () => {
                        this.multValue = endValue;
                        this.linkSpineValueText.setText(Utils.formatValue(endValue));
                        await Utils.wait(waitTime, this.scene);
                        resolve(true);
                    }
                });
            }
        });
    }
}